import React, { useEffect, useState } from 'react';
import MobileAR from "./MobileAR";

export default function ARLanding() {

    return (
        <div style={{height: '100vh', width: '100%', backgroundColor: '#212121', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <MobileAR
                glbSrc="/images/PalazzoDucale7_Anim.glb"
                usdzSrc="/images/PalazzoDucale7_Anim.usdz"
            />
        </div>
    );
}
